// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgm_a","AdSlotBranding__desktop":"bgm_b","AdSlotBranding__mobile":"bgm_c"};